// Shortcuts under the bridge (vents, spec GP-13). Agberos only, on the road: hop in at a shortcut,
// cross to a linked one, climb out. While in, the keke is gone from every living view, cannot be
// knocked and cannot act. Climbing out starts a cooldown before the next hop. A meeting pulls
// everyone out where they are. Deterministic: only state.now.
import { getMap, TILE } from '@wahala/maps';
import { dist2 } from './geometry.js';
export const VENT_RADIUS = 1.2 * TILE;
export const VENT_COOLDOWN_MS = 10_000;
export function checkVent(s, p, action, ventId, 
/** The mode's refusal (rules.ts mayVent: agberos only in classic), or null. */
refusal = p.role === 'impostor' ? null : 'NOT_IMPOSTOR') {
    if (s.phase !== 'PLAYING')
        return 'WRONG_PHASE';
    if (refusal)
        return refusal;
    if (!p.alive)
        return 'NOT_ALIVE';
    const vents = getMap(s.mapId).vents;
    if (action === 'enter') {
        if (p.vent !== null)
            return 'IN_VENT';
        if (s.now < p.ventCooldownUntil)
            return 'COOLDOWN';
        const v = vents.find((x) => x.id === ventId);
        if (!v)
            return 'BAD_TARGET';
        return dist2(p.pos, v.pos) <= VENT_RADIUS * VENT_RADIUS ? null : 'OUT_OF_RANGE';
    }
    if (p.vent === null)
        return 'NOT_IN_VENT';
    if (action === 'exit')
        return null;
    const here = vents.find((x) => x.id === p.vent);
    return here?.adjacent.includes(ventId ?? '') ? null : 'BAD_TARGET';
}
export function enterVent(s, p, ventId, events) {
    const v = getMap(s.mapId).vents.find((x) => x.id === ventId);
    if (!v)
        return;
    p.vent = v.id;
    p.pos = { ...v.pos };
    p.vel = { x: 0, y: 0 };
    p.input = { dx: 0, dy: 0 };
    s.sessions[p.id] = null;
    events.push({ t: 'vent.entered', playerId: p.id, ventId: v.id });
}
export function moveVent(s, p, ventId, events) {
    const v = getMap(s.mapId).vents.find((x) => x.id === ventId);
    if (!v)
        return;
    p.vent = v.id;
    p.pos = { ...v.pos };
    events.push({ t: 'vent.moved', playerId: p.id, ventId: v.id });
}
export function exitVent(s, p, events) {
    if (p.vent === null)
        return;
    const ventId = p.vent;
    p.vent = null;
    p.ventCooldownUntil = s.now + VENT_COOLDOWN_MS;
    events?.push({ t: 'vent.exited', playerId: p.id, ventId });
}
//# sourceMappingURL=vents.js.map